import React from "react";
import style from './style.module.css'

const RadioTab = props => {

  const { options, value, setvalue } = props;

  return (
    <div className={style.tab}>
      {options.map(__option => (
        <button
          type="button"
          className={style.option}
          data-selected={__option.value === value ? "true" : "false"}
          onClick={() => { setvalue(__option.value) }}
        >
          <span>{__option.label}</span>
        </button>
      ))}
    </div>
  )
}

export default RadioTab;
